import blockchaindevelopment from "../Assets/Images/Blockchain-Develeopment.svg";
import Ethereum from "../Assets/Images/etherium.svg";
import Solana from "../Assets/Images/Solana.svg";
import Cardano from "../Assets/Images/caradano.svg";
import Hyperledger from "../Assets/Images/Hyerledger.svg";
import Binance from "../Assets/Images/Binance.svg";
import Thorchain from "../Assets/Images/Thorchain-1.svg";
import { Link } from "react-router-dom";

const technologies = [
  { name: "Ethereum", image: Ethereum },
  { name: "Solana", image: Solana },
  { name: "Cardano", image: Cardano },
  { name: "Hyperledger", image: Hyperledger },
  { name: "Binance", image: Binance },
  { name: "Thorchain", image: Thorchain },
];

const BlockchainDev = () => {
  return (
    <>
      <div className="relative bg-night overflow-hidden">
        <div className="glow-orb w-[320px] h-[320px] bg-neonPurple/20 top-10 -left-24"></div>
        <div className="max-w-[1140px] mx-auto py-20 p-4 relative">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white">
            The Technologies We <span className="text-gradient">Work With</span>
          </h1>
          <div className="web3-underline w-[80px] mt-3"></div>
          <p className="py-8 text-gray-400">
            We use the latest technological solutions to offer you premium, high
            value services.
          </p>
          <div className="grid lg:grid-cols-2 py-6 items-center gap-10">
            <div data-aos="fade-up" className="animate-float">
              <img src={blockchaindevelopment} alt="" />
            </div>
            <div>
              <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white">
                Blockchain <span className="text-gradient">Development</span>
              </h1>
              <p className="py-7 text-gray-400">
                We use the latest technological solutions to offer you premium,
                high value services.
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {technologies.map((tech) => (
                  <div
                    key={tech.name}
                    className="glass-card flex items-center justify-center flex-col py-6"
                  >
                    <img className="w-14" src={tech.image} alt={tech.name} />
                    <p className="text-gray-300 pt-4">{tech.name}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="relative bg-nightSoft text-white py-2 overflow-hidden border-y border-white/10">
        <div className="glow-orb w-[280px] h-[280px] bg-customRed/20 top-0 right-10"></div>
        <div className="max-w-[1140px] mx-auto my-14 p-4 relative">
          <div className="grid lg:grid-cols-2 gap-5 place-items-center">
            <div>
              <h1 data-aos="fade-right" className="text-3xl font-bold">
                Integrate your business with our{" "}
                <span className="text-gradient">dynamic software solutions</span>
              </h1>
            </div>
            <div>
              <Link to="/contactUs">
                <button className="bg-customRed neon-btn hover:scale-110 transition ease-in-out text-white font-bold py-3 px-8 rounded-full">
                  Talk to Our Expert
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlockchainDev;
